// extracted by mini-css-extract-plugin
export default {"ellipsis":"Cell_ellipsis__LqcQ9"};